<template>
  <div class="d-flex align-items-center min-vh-100">
    <b-container>
      <b-row class="justify-content-center">
        <h1 class="display-3 mr-4">404</h1>
        <div>
          <h4 class="pt-3">{{$t('page404_view.title')}}</h4>
          <p class="text-muted">
            {{$t('page404_view.content')}}
          </p>
        </div>
        <b-button class="mt-4" block variant="primary" to="/">
          {{$t('page_title.home')}}
        </b-button>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'Page404',
  created() {
    window.document.title = 'Error 404'
  }
}
</script>
